import { render, staticRenderFns } from "./ClaimAdd.vue?vue&type=template&id=24c03d20&"
import script from "./ClaimAdd.vue?vue&type=script&lang=js&"
export * from "./ClaimAdd.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports